import { PMProgressBar } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { theme } from "../../../theme";
import { DashboardCardContext } from "../context";

export function addProgressCard(ctx: DashboardCardContext) {
  const { view, itemName } = ctx;

  const progressComponent = view.addComponent({
    component: PMProgressBar,
    layoutProps: {
      componentId: "progressComponent",
      title: "",
      description: "",
      labels: ["progress"],
    },
  });

  progressComponent.mapLayoutProps(({ language }) => ({
    componentId: "progressComponent",
    labels: ["progress"],
    title: getLocalizedMessage(language, "progress"),
    description: getLocalizedMessage(
      language || "en",
      "showsReportingProgress"
    ),
  }));

  progressComponent.mapState(({ dashboard, language }) => {
    return {
      label: getLocalizedMessage(language, "progress"),
      title: itemName,
      trackColor: "#EEE",
      barColor: theme.palette.primary.contrastText,
      percent: dashboard?._calculated?.averageProgress ?? 0,
    };
  });

  progressComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "itemReporting")
        .find((field) => field.fieldName === "progress")?.enabled === true
  );
}
